// extracted by mini-css-extract-plugin
export default {"clientsHeader":"styles_clientsHeader__79gCB","icon":"styles_icon__QyCx4","headerRight":"styles_headerRight__OBWPO"};